import { useCallback, useState } from 'react'
import { useVoiceWebSocket } from './useVoiceWebSocket'

export type VoiceState = 'idle' | 'listening' | 'thinking' | 'speaking'

interface UseVoiceModeReturn {
  state: VoiceState
  isActive: boolean
  message: string | undefined
  startVoice: () => void
  stopVoice: () => void
}

export function useVoiceMode(): UseVoiceModeReturn {
  const [message, setMessage] = useState<string | undefined>(undefined)

  const { voiceState, connect, disconnect, aiText, fullText } = useVoiceWebSocket()

  // Sync messages
  if (aiText && aiText !== message) setMessage(aiText)
  if (fullText) {
    window.dispatchEvent(new CustomEvent('runai:agent-message', {
      detail: { content: fullText, agentName: 'Voice AI', fromUser: false }
    }))
  }

  const startVoice = useCallback(() => connect(), [connect])
  const stopVoice = useCallback(() => {
    disconnect()
    setMessage(undefined)
  }, [disconnect])

  return {
    state: voiceState as VoiceState,
    isActive: voiceState !== 'idle',
    message,
    startVoice,
    stopVoice,
  }
}
